import React from "react";
import MultiFormEditor from "../../components/multiForm/MultiFormEditor";
import MultiFormProvider from "../../provider/multiForm/MultiFormProvider";

export default function MultiForm () {
  return <MultiFormProvider>
    <MultiFormEditor/>
  </MultiFormProvider>
};